import palette from '../../palette';

export default {
  root: {
    color: palette.grayText,
    fontSize: "13px",
    "&$error": {
      "&$focused": {
        color: palette.redError
      },
    },
    "&$focused": {
      color: palette.blueMain
    },
    "&$outlined": {
      transform: "translate(12px, 12px) scale(1)",
      marginBottom: "0px",
      "&$shrink": {
        transform: "translate(12px, -6px) scale(0.75)",
        backgroundColor: palette.white,
        padding: "0px 5px"
      }
    }
  },
  filled: {
    textTransform: "none",
    transform: "translate(12px, 12px) scale(1)",
    "&$shrink": {
      transform: "translate(12px, 6px) scale(0.7)",
    }
  },
};
